import {Grid} from "@mui/material";
import React from "react";

export default function MfaTotpImage(props: any) {
    return <Grid container sx={props.sx}>
        <img
            src={process.env.PUBLIC_URL + "/media/lxo-mfa-totp.svg"}
            alt="MfaTotpDevice"
            height={props.height ? props.height : "130px"}
            width={"100%"}
        />
    </Grid>
}